<template>
  <div v-loading.fullscreen="loading">
    <div class="header">
      <el-button
        class="upload-demo"
        type="success"
        @click="showFileDownloadModal = true"
        v-if="$store.state.role === 'admin'"
      >
        <img
          style="margin-right: 10px"
          alt=""
          src="@/assets/images/icons/download.svg"
        />
        Mavjud Aholi Soni ro'yxatini yuklab olish
      </el-button>

      <el-button
        @click="showFileUploadModal = true"
        v-if="$store.state.role === 'admin'"
      >
        Aholi sonini Excel orqali kiritish
      </el-button>

      <el-select
        v-if="$store.state.role === 'admin'"
        v-model="selectedRegion"
        placeholder="Viloyatlar"
        @change="getDistricts"
        :loading="regionsLoading"
      >
        <el-option value="" label="Barchasi" />
        <el-option
          v-for="region in regions"
          :key="region.id"
          :value="region.id"
          :label="region.title"
        />
      </el-select>
      <el-select
        v-if="$store.state.role === 'admin'"
        placeholder="Tuman/Shaxar"
        v-model="district_id"
        :loading="loading"
        @change="getPopulationList"
      >
        <el-option value="" label="Barchasi" />

        <el-option
          v-for="district in districts"
          :key="district.id"
          :value="district.id"
          :label="district.title"
        />
      </el-select>
      <el-select placeholder="Yil" v-model="year" @change="getPopulationList">
        <el-option value="" label="Barchasi" />
        <el-option v-for="y in years" :key="y" :value="y" :label="y" />
      </el-select>

      <el-button
        class="custom-btn"
        @click="() => this.$router.push({ name: 'PopulationAdd' })"
        type="primary"
        >Qo'shish</el-button
      >
    </div>
    <el-table :data="populations" border height="calc(100vh - 210px)">
      <el-table-column type="index" />
      <el-table-column prop="region" label="Viloyat" min-width="250" />
      <el-table-column prop="district" label="Tuman/Shahar" min-width="150" />
      <el-table-column
        prop="citizens_count"
        label="Aholi soni"
        min-width="150"
      />
      <el-table-column prop="year" label="Yil" min-width="150" />
      <el-table-column
        prop="created_at"
        label="Yaratilgan sana"
        min-width="200"
      >
        <template #default="scope">
          {{ $moment(scope.row.created_at).format("DD.MM.YYYY HH:mm") }}
        </template>
      </el-table-column>
      <el-table-column width="200" label="Tahrirlash">
        <template #default="scope">
          <el-button
            size="small"
            @click="onEditPopulation(scope.row.id)"
            type="primary"
            >Tahrirlash</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <div>Aholi soni: {{ totalCount }}</div>
      <el-pagination
        background
        layout="sizes, prev, pager, next"
        :total="totalCount"
        v-model:page-size="limit"
        v-model:current-page="currentPage"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog v-model="showFileUploadModal" title="Aholi soni">
      <el-form :model="form" :rules="rules" ref="formRef">
        <el-form-item label="" prop="year">
          <el-select v-model="form.year" placeholder="Yilni kiriting">
            <el-option v-for="y in years" :key="y" :value="y" :label="y" />
          </el-select>
        </el-form-item>
      </el-form>
      <el-form-item prop="file">
        <el-upload
          ref="uploadRef"
          class="upload-demo"
          :action="uploadUrl"
          :headers="uploadHeader"
          :data="form"
          :multiple="false"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          :limit="1"
          :on-exceed="onExceed"
          :on-success="onSuccessUpload"
          :on-error="onErrorUpload"
          :before-upload="onBeforeUpload"
        >
          <template #trigger>
            <el-button style="width: 100%" type="primary">
              Excel yuklang
            </el-button>
          </template>
        </el-upload>
      </el-form-item>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="showFileUploadModal = false">Rad etish</el-button>
        </span>
      </template>
    </el-dialog>

    <el-dialog v-model="showFileDownloadModal" title="Aholi soni">
      <el-form :model="form" :rules="rules" ref="downloadFormRef">
        <el-form-item label="" prop="year">
          <el-select v-model="form.year" placeholder="Yilni kiriting">
            <el-option v-for="y in years" :key="y" :value="y" :label="y" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button  type="success" @click="downloadExcel">
            Mavjud Aholi Soni ro'yxatini yuklab olish
          </el-button>
        </el-form-item>
      </el-form>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="showFileDownloadModal = false"
            >Rad etish</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ElNotification } from "element-plus";

export default {
  name: "PopulationList",
  data() {
    return {
      uploadUrl: `${process.env.VUE_APP_BASE_API_URL}api/v1/citizens-count/sync-excel`,
      uploadHeader: { Authorization: `${this.$store.state.accessToken}` },
      form: { year: null },
      loading: false,
      regionsLoading: false,
      totalCount: 0,
      limit: 20,
      showFileUploadModal: false,
      showFileDownloadModal: false,
      currentPage: 1,
      regions: [],
      years: [],
      districts: [],
      populations: [],
      selectedRegion: null,
      district_id: null,
      year: null,
      rules: {
        year: [
          { required: true, message: "Yilni tanlang!", trigger: "change" },
        ],
      },
    };
  },

  methods: {
    onBeforeUpload() {
      let isValid = this.$refs.formRef.validate((valid) => {
        this.loading = valid;
        return valid;
      });
      console.log("isValid", isValid);

      return isValid;
    },
    onSuccessUpload() {
      console.log("success upload");
      this.loading = false;
      this.showFileUploadModal = false;
      this.form.year = null;
      ElNotification.success({
        message: "Amaliyot muvaffaqiyatli bajarildi!",
      });
      this.getPopulationList();
    },
    onErrorUpload(error) {
      if (error.status === 401) {
        this.$store.commit("signOut");
        this.$router.push({ name: "Auth" });
      }
      ElNotification.error({
        message:
          JSON.parse(error?.message)?.message ||
          "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
        type: "error",
      });

      this.loading = false;
    },
    onExceed(files) {
      console.log("exceeds", files);
      // this.form.file[0] = files[0]
    },

    onEditPopulation(id) {
      this.$router.push({ name: "PopulationEdit", params: { id } });
    },
    getRegions() {
      this.regionsLoading = true;
      this.$http
        .get("/api/v1/regions")
        .then(({ data }) => {
          this.regions = data.regions;
          this.getPopulationList();
        })
        .catch(() => {})
        .finally(() => {
          this.regionsLoading = false;
        });
    },

    downloadExcel() {
      this.$refs.downloadFormRef.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$http
            .get(`api/v1/citizens-count/excel`, {
              responseType: "blob",
              params: {
                year: this.form.year,
              },
            })
            .then((res) => {
              const url = URL.createObjectURL(
                new Blob([res.data], {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
                })
              );
              const header = res.headers.get("Content-Disposition");
              const parts = header.split(";");
              let fileName = parts[1].split("=")[1];
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", fileName);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              this.showFileDownloadModal = !this.showFileDownloadModal
            })
            .catch(({ response }) => {
              ElNotification({
                title: "Ogohlantirish",
                message:
                  response.data.message ||
                  "Ma'lumot yuklashda xatolik sodir bo'ldi!",
                type: "warning",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },

    getDistricts() {
      this.$http
        .get(`api/v1/districts`, {
          params: {
            region_id: this.selectedRegion,
          },
        })
        .then(({ data }) => {
          this.districts = data.districts;
          this.getPopulationList();
        })
        .catch((err) => {
          console.error("quarters fetch error", err);
        });
    },

    getYears() {
      this.$http
        .get(`api/v1/citizens-count/years`)
        .then(({ data }) => {
          console.log(data);
          this.years = data.years;
        })
        .catch((err) => {
          console.error("quarters fetch error", err);
        });
    },
    validateUser() {
      if (this.$store.state.user.role === "admin") {
        this.regionId = this.selectedRegion;
        this.districtId = this.district_id;
      } else if (this.$store.state.user.role === "moderator") {
        this.regionId = this.$store.state.user.region_id;
        this.districtId = this.$store.state.user.district_id;
      } else if (this.$store.state.user.role === "region_manager") {
        this.regionId = this.$store.state.user.region_id;
        this.districtId = null;
      }
    },
    // Rest of your methods
    getPopulationList() {
      this.validateUser();
      this.loading = true;
      this.$http
        .get("/api/v1/citizens-count", {
          params: {
            region_id: this.regionId,
            district_id: this.districtId,
            year: this.year,
            limit: this.limit,
            offset: this.limit * (this.currentPage - 1),
          },
        })
        .then(({ data }) => {
          this.populations = data.results;
          this.totalCount = data.count;
        })
        .catch(({ response }) => {
          ElNotification({
            type: "error",
            title: "Xatolik",
            message: response.data.message || "Yuklashda xatolik sodir bo'ldi",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCurrentChange() {
      this.$router.replace({
        query: { ...this.$route.query, page: this.currentPage },
      });
      this.getPopulationList();
    },
    handleSizeChange() {
      this.$router.replace({
        query: { ...this.$route.query, size: this.limit, page: 1 },
      });
      this.currentPage = 1;
      this.getPopulationList();
    },
  },

  mounted() {
    this.getDistricts();
    this.getYears();
    this.getRegions();
    if (this.$route.query.size) {
      this.limit = parseInt(this.$route.query.size);
    }
    if (this.$route.query.page) {
      this.currentPage = parseInt(this.$route.query.page);
    }
  },
};
</script>

<style scoped>
.header {
  display: flex;
  margin-bottom: 10px;
  gap: 10px;
  justify-content: flex-end;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}
</style>
